// extracted by mini-css-extract-plugin
export default {"form":"IntegrationEbayModal_form__MjyLj","body":"IntegrationEbayModal_body__1G0wF","footer":"IntegrationEbayModal_footer__lYcFG","button":"IntegrationEbayModal_button__9MH-+"};